
import { Component, PropSync, Vue } from "vue-property-decorator";
import OModal from "@/views/dashboard/overview/Modal.vue";
import DashboardTile from "@/components/DashboardTile.vue";
import { Dash } from "@/hooks";
import logger from "@/plugins/logger";
import dayjs from "dayjs";

@Component({
  components: {
    OModal,
    DashboardTile,
  },
})
export default class Other extends Vue {
  @PropSync("loading") load!: boolean;
  overviewModal = false;
  psiraRenewedHeaders = [
    { text: "ARO/SO", value: "isSecurityGuard" },
    { text: "Name", value: "aroName" },
    { text: "PSIRA Reg No", value: "registrationNumber" },
    { text: "Grade", value: "grade" },
    { text: "Expiry Date", value: "expiryDate" },
    { text: "Days to Expiry", value: "daysToExpiryCalc" },
  ];
  firearmRenewedHeaders = [
    { text: "Firearm", value: "firearmDisplay" }, // make + model
    { text: "Serial Number", value: "serialNumber" },
    { text: "Expiry Date", value: "expiryDateStr" },
    { text: "Days to Expiry", value: "daysToExpiryCalc" },
    { text: "Follow Up Date", value: "followUpDateStr" },
  ];
  sapsRenewedHeaders = [
    { text: "ARO/SO", value: "isSecurityGuard" },
    { text: "Full Name", value: "fullName" }, // new column
    { text: "Firearm Type", value: "firearmType" },
    { text: "Expiry Date", value: "expiryDate" },
    { text: "Days to Expiry", value: "daysToExpiryCalc" },
    { text: "Follow Up Date", value: "followUpDate" },
  ];
  drivingRenewedHeaders = [
    { text: "ARO/SO", value: "isSecurityGuard" },
    { text: "Full Name", value: "aroName" },
    { text: "Expiry Date", value: "expiryDateStr" },
    { text: "Days to Expiry", value: "daysToExpiryCalc" },
    { text: "Follow Up Date", value: "followUpDate" },
  ];
  firearmRenewalsFollowupsHeaders = [
    { text: "Firearm", value: "firearmDisplay" },
    { text: "Serial Number", value: "serialNumber" },
    { text: "Follow Up Date", value: "followUpDateStr" },
    { text: "Renewal Submittor", value: "submittedBy" },
    { text: "Place Of Renewal", value: "policeStation" },
    { text: "Follow Up Instructions", value: "followUpInstructions" },
  ];

  sapsCompetencyRenewalsFollowupsHeaders = [
    { text: "ARO/SO", value: "isSecurityGuard" },
    { text: "Full Name", value: "fullName" },
    { text: "Firearm Type", value: "firearmType" },
    { text: "Expiry Date", value: "expiryDate" },
    { text: "Follow Up Date", value: "followUpDate" },
  ];

  drivingLicenceRenewalsFollowupsHeaders = [
    { text: "ARO/SO", value: "isSecurityGuard" },
    { text: "Name", value: "aroName" },
    { text: "Follow Up Date", value: "followUpDateStr" },
    { text: "Renewal Submittor", value: "submittedBy" },
    { text: "Place Of Renewal", value: "submittedWhere" },
  ];
  td: any[] = [];
  modalData = {
    tableData: this.td,
    tableHeaders: this.psiraRenewedHeaders,
    tableName: "",
    title: "",
    sortBy: "",
  };

  async openModal(i: {
    color: string;
    icon: string;
    title: string;
    value: number;
    name: string;
    colorCheck: string;
    category?: string;
  }): Promise<void> {
    this.load = true;
    this.modalData.title = i.title;

    if (i.name == "psiraRenewed") {
      try {
        const res = await Dash.GetPSIRAListRenewal(1);
        this.modalData.tableData = res;
        this.modalData.tableData.forEach((item, i) => {
          item.id = i + 1;
        });
        this.modalData.tableHeaders = this.psiraRenewedHeaders;
        this.modalData.tableName = i.name;
        this.modalData.sortBy = "expiryDate";
      } catch (err) {
        return Promise.reject(err);
      }
    } else if (i.name == "firearmRenewed") {
      try {
        const res = await Dash.GetFirearmListRenewal(2);
        this.modalData.tableData = res.map((item) => ({
          ...item,
          firearmDisplay: `${item.make || ""} ${item.model || ""}`.trim(),
          followUpDateStr: item.followUpDate
            ? dayjs(item.followUpDate).format("YYYY-MM-DD")
            : "",
          followUpInstructions:
            !item.followUpInstructions ||
            item.followUpInstructions.trim() === ""
              ? "None"
              : item.followUpInstructions,
        }));
        this.modalData.tableData.forEach((item, i) => {
          item.id = i + 1;
        });
        this.modalData.tableHeaders = this.firearmRenewedHeaders;
        this.modalData.tableName = i.name;
        this.modalData.sortBy = "expiryDate";
      } catch (err) {
        return Promise.reject(err);
      }
    } else if (i.name == "sapsRenewed") {
      try {
        const res = await Dash.GetSAPSListRenwal(3);
        this.modalData.tableData = res.map((item, idx) => ({
          ...item,
          fullName: `${item.aroName || ""} ${item.aroSurname || ""}`.trim(),
          followUpDate: item.followUpDate
            ? dayjs(item.followUpDate).format("YYYY-MM-DD")
            : "",
          id: idx + 1,
        }));
        this.modalData.tableHeaders = this.sapsRenewedHeaders;
        this.modalData.tableName = i.name;
        this.modalData.sortBy = "daysToExpiryCalc";
      } catch (err) {
        return Promise.reject(err);
      }
    } else if (i.name == "drivingRenewed") {
      try {
        const res = await Dash.GetDrivingLicenseRenewal(9);
        this.modalData.tableData = res.map((item, idx) => ({
          ...item,
          expiryDateStr: item.expiryDateStr
            ? item.expiryDateStr
            : item.expiryDate
            ? dayjs(item.expiryDate).format("YYYY-MM-DD")
            : "",
          followUpDate: item.followUpDate
            ? dayjs(item.followUpDate).format("YYYY-MM-DD")
            : "",
          aroName: item.aroName || "",
          imagePath: item.imagePath || "",
          daysToExpiryCalc: item.daysToExpiryCalc || "",
          id: idx + 1,
        }));
        this.modalData.tableHeaders = this.drivingRenewedHeaders;
        this.modalData.tableName = i.name;
        this.modalData.sortBy = "expiryDateStr";
      } catch (err) {
        return Promise.reject(err);
      }
    } else if (i.name == "firearmRenewalsFollowupsCount") {
      try {
        const res = await Dash.GetFirearmRenewalFollowUps();
        this.modalData.tableData = res.map((item, idx) => ({
          ...item,
          firearmDisplay: `${item.make || ""} ${item.model || ""}`.trim(),
          expiryDateStr: item.expiryDate
            ? dayjs(item.expiryDate).format("YYYY-MM-DD")
            : "",
          followUpDateStr: item.followUpDate
            ? dayjs(item.followUpDate).format("YYYY-MM-DD")
            : "",
          id: idx + 1,
        }));
        this.modalData.tableHeaders = this.firearmRenewalsFollowupsHeaders;
        this.modalData.tableName = i.name;
        this.modalData.sortBy = "followUpDateStr";
      } catch (err) {
        return Promise.reject(err);
      }
    } else if (i.name == "sapsCompetencyRenewalsFollowupsCount") {
      try {
        const res = await Dash.GetSapsCompetencyFollowUps();
        this.modalData.tableData = res.map((item, idx) => ({
          ...item,
          fullName: `${item.aroName || ""} ${item.aroSurname || ""}`.trim(),
          followUpDate: item.followUpDate
            ? dayjs(item.followUpDate).format("YYYY-MM-DD")
            : "",
          id: idx + 1,
        }));
        this.modalData.tableHeaders =
          this.sapsCompetencyRenewalsFollowupsHeaders;
        this.modalData.tableName = i.name;
        this.modalData.sortBy = "followUpDate";
      } catch (err) {
        return Promise.reject(err);
      }
    } else if (i.name == "drivingLicenceRenewalsFollowupsCount") {
      try {
        const res = await Dash.GetDriversLicenseFollowUps();
        this.modalData.tableData = res.map((item, idx) => ({
          ...item,
          expiryDateStr: item.expiryDate
            ? dayjs(item.expiryDate).format("YYYY-MM-DD")
            : "",
          followUpDateStr: item.followUpDate
            ? dayjs(item.followUpDate).format("YYYY-MM-DD")
            : "",
          id: idx + 1,
        }));
        this.modalData.tableHeaders =
          this.drivingLicenceRenewalsFollowupsHeaders;
        this.modalData.tableName = i.name;
        this.modalData.sortBy = "followUpDateStr";
      } catch (err) {
        return Promise.reject(err);
      }
    }
    this.load = false;
    this.overviewModal = true;
  }

  colorEval(str: string): string {
    logger.log(str);
    return eval(str);
  }
  async mounted(): Promise<void> {
    try {
      this.load = true;
      const res = await Dash.GetDashboardCounts();
      this.dash.forEach((el) => {
        const index = Object.keys(res).find((i: string) => i == el.name);
        if (index != undefined) {
          el.value = res[index];
        }
      });
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.load = false;
    }
  }
  dash: {
    color: string;
    icon: string;
    title: string;
    value: number;
    name: string;
    colorCheck: string;
    category?: string;
  }[] = [
    /* {
      color: "teal lighten-1",
      icon: "mdi-autorenew",
      title: "PSIRA Registrations Renewals Submitted",
      value: -1,
      name: "psiraRenewed",
      colorCheck: "<= 0",
    }, */
    /* {
      color: "orange lighten-2",
      icon: "mdi-autorenew",
      title: "Number of Firearm related incidents in the past 90 days",
      value: -1,
      name: "regulationRenewed",
      colorCheck: "> 0",
    }, */
    {
      color: "teal lighten-1",
      icon: "mdi-autorenew",
      title: "Firearms Renewals Submitted",
      value: -1,
      name: "firearmRenewed",
      colorCheck: "<= 0",
      category: "firearm",
    },
    {
      color: "orange lighten-2",
      icon: "mdi-autorenew",
      title: "Firearm Renewals Follow Ups",
      value: -1,
      name: "firearmRenewalsFollowupsCount",
      colorCheck: "<= 0",
      category: "firearm",
    },
    {
      color: "orange lighten-2",
      icon: "mdi-autorenew",
      title: "SAPS Competency Renewals Submitted",
      value: -1,
      name: "sapsRenewed",
      colorCheck: "<= 0",
      category: "saps",
    },
    {
      color: "orange lighten-2",
      icon: "mdi-autorenew",
      title: "SAPS Competency Renewals Follow Ups",
      value: -1,
      name: "sapsCompetencyRenewalsFollowupsCount",
      colorCheck: "<= 0",
      category: "saps",
    },
    {
      color: "orange lighten-2",
      icon: "mdi-autorenew",
      title: "Driving License Renewals Submitted",
      value: -1,
      name: "drivingRenewed",
      colorCheck: "<= 0",
      category: "driving",
    },
    {
      color: "orange lighten-2",
      icon: "mdi-autorenew",
      title: "Driving License Renewals Follow Ups",
      value: -1,
      name: "drivingLicenceRenewalsFollowupsCount",
      colorCheck: "<= 0",
      category: "driving",
    },
  ];

  getItemByName(name: string) {
    const item = this.dash.find((item) => item.name === name);
    return (
      item || {
        color: "gray",
        icon: "mdi-help",
        title: "Not Found",
        value: -1,
        name: "",
        colorCheck: "< 0",
        category: "unknown",
      }
    );
  }

  getCategoryItems(category: string) {
    return this.dash.filter((item) => item.category === category);
  }
}
